import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {take} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class HumanInteractionService {

  constructor(private http: HttpClient, @Inject('BASE_URL') private baseUrl: string) { }

  getInteractionQueue() {
    return this.http.get<any>(`api/runtime/getInteractionQueue`);
  }

  getPagedInteractionQueueItems(filter) {
    return this.http.post<any>('api/inMemory/getPagedInteractionQueueItems', filter);
  }

  getCustomInteractionQueueConfig(businessProcessId = null, stateId = null) {
    return this.http.post<any>(`api/getCustomInteractionQueueConfig`, {businessProcessId: businessProcessId, stateId: stateId});
  }

  getCustomInteractionQueueConfigById(queueId) {
    return this.http.get<any>(`api/GetCustomInteractionQueueConfigById/${queueId}`);
  }

  getTotalsPerAgreementItems(filter) {
    return this.http.post<any>('api/inMemory/getTotalsPerAgreementItems', filter);
  }

  getInteractionQueueForEdit() {
    return this.http.get<any>(`api/interactionQueue/get`);
  }

  updateInteractionQueue(interactionQueue) {
    return this.http.post<any>('api/interactionQueue/update', interactionQueue);
  }

  requestRefreshInteractionQueue() {
    return this.http.get<any>(`api/interactionQueue/requestRefreshInteractionQueue`);
  }

  getUserFavoriteQueues() {
    return this.http.get<any[]>('api/customQueue/getFavQueuesByUser');
  }

  addQueueToFavorite(customQueueId: number) {
    return this.http.post<any>('api/customQueue/addToFavorite', {customQueueId: customQueueId});
  }

  removeQueueFromFavorite(customQueueId: number) {
    return this.http.delete(`api/customQueue/removeFromFavorite/${customQueueId}`)
      .pipe(take(1));
  }

  allocateNextInstance() {
    return this.http.get<any[]>('api/runtime/allocateNextInstanceForHumanInteraction');
  }

  allocateNextInstanceCustom() {
    return this.http.get<any[]>('api/runtime/allocateNextInstanceInCustomQueueForHumanInteraction');
  }

  startBusinessProcess(businessProcessId) {
    return this.http.get<any>(`api/runtime/startBusinessProcess/${businessProcessId}`);
  }
}
